import { Box, Button, Grid, styled, Typography } from "@mui/material";
import {
  DataGrid,
  GridColDef,
  GridToolbar,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import * as React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useFetchAllDivisi from "../../../../api/effects/queries/Divisi/useFetchAllDivisi";
import useFetchAdminAllJob from "../../../../api/effects/queries/Job/useFetchAdminAllJob";
import { DivisiResponse } from "../../../../models/Divisi";
import { AdminJobDetailResponse } from "../../../../models/Job";
import { convertDate } from "../../../../utils/dateConvert";
import { CustomToolbar } from "../../HeaderHR";
import JobModal from "./JobModal";

const BoxTable = styled(Box)({
  maxWidth: "1280px",
  height: "70vh",
  width: "100%",
});

export default function JobTable() {
  const columns: GridColDef[] = [
    {
      field: "JOB_ID",
      headerName: "Job ID",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    { field: "DIVISI_ID", headerName: "Divisi", flex: 1 },
    { field: "JOB", headerName: "Job", flex: 1 },
    { field: "LOKASI", headerName: "Lokasi", flex: 1 },
    { field: "STATUS_KARYAWAN", headerName: "Status Karyawan", flex: 1 },
    {
      field: "TANGGAL_DIBUAT",
      headerName: "Tanggal Dibuat",
      flex: 1,
      renderCell: (params: GridValueGetterParams) => {
        return convertDate(params.row.TANGGAL_DIBUAT);
      },
    },
    {
      field: "IS_ACTIVE",
      headerName: "Is Active",
      type: "boolean",
      flex: 1,
    },

    {
      field: "action",
      headerName: "Action",
      sortable: false,
      renderCell: (params: GridValueGetterParams) => {
        const onClick = () => {
          handleOpenModalEdit(params.row.JOB_ID);
        };
        return <Button onClick={onClick}>Edit</Button>;
      },
      headerAlign: "center",
      align: "center",
    },
  ];
  const { data: allJobData } = useFetchAdminAllJob();

  const [data, setData] = useState<AdminJobDetailResponse[]>();

  useEffect(() => {
    if (allJobData !== undefined) {
      setData(allJobData);
    }
  }, [allJobData]);

  const [IDState, setIDState] = useState(-1);
  const [modalState, setModalState] = useState(false);

  const handleOpenModalAdd = () => {
    setIDState(-1);
    setModalState(!modalState);
  };
  const handleOpenModalEdit = (e: number) => {
    setIDState(e);
    setModalState(!modalState);
  };

  const handleCloseModal = () => {
    setModalState(!modalState);
  };

  return (
    <>
      <JobModal open={modalState} handleClose={handleCloseModal} ID={IDState} />
      <Grid
        container
        justifyContent="flex-start"
        sx={{
          maxWidth: "1280px",
          paddingBottom: "1vh",
        }}
      >
        <Typography variant="h4">Tabel Job</Typography>
      </Grid>
      <BoxTable>
        {data !== undefined ? (
          <DataGrid
            rows={data}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            getRowId={(data) => data.JOB_ID}
            disableColumnMenu
            components={{ Toolbar: CustomToolbar }}
          />
        ) : (
          <div />
        )}
      </BoxTable>
      <Grid
        container
        justifyContent="flex-end"
        sx={{
          maxWidth: "1280px",
          paddingTop: "2vh",
        }}
      >
        <Button variant="contained" onClick={handleOpenModalAdd}>
          Tambah Job
        </Button>
      </Grid>
    </>
  );
}
